const CLIENTES = [
  { nome: "Grupo Natureza", logo: "/logos/grupo-natureza.png" },
  { nome: "ENEC", logo: "/logos/enec.svg" },
  { nome: "Grupo Navesa", logo: "/logos/grupo-navesa.png" },
  { nome: "Saga", logo: "/logos/saga.png" },
];

const ClientesSection = () => {
  return (
    <section className="py-20 bg-primary text-primary-foreground">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Nossos Clientes
          </h2>
          <p className="text-primary-foreground/70 max-w-2xl mx-auto">
            Há mais de 10 anos levando produtos e serviços para os mais diversos
            e seletos segmentos empresariais, pessoas físicas e ambientes
            condominiais.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 items-center justify-items-center">
          {CLIENTES.map((c) => (
            <div key={c.nome} className="flex items-center justify-center">
              <img
                src={c.logo}
                alt={`Logo ${c.nome}`}
                loading="lazy"
                decoding="async"
                width={160}
                height={64}
                sizes="160px"
                className="h-16 max-h-16 object-contain brightness-200 hover:scale-105 hover:brightness-[2.5] transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientesSection;
